__turbopack_context__.v({
  "className": "public_sans_c04fba6f-module__czALtq__className",
});
